// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectDevelopers/Keys/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectDevelopers_Keys{
  apps_keys(order_by: { created_at: desc }) {
    id
    key
    description
    masked_secret
    status
    expires_at
  }
}

`